import localforage from "localforage";
import sms from "./sms.module";

const defaultAutoRefreshInterval = 1000 * 60 * 5;
const autoRefreshIntervalKey = "mb.auto_refresh_interval";

export default {
    state: {
        autoRefreshOptions: [
            { name: "2 minutes", value: 1000 * 60 * 2 },
            { name: "5 minutes", value: 1000 * 60 * 5 },
            { name: "15 minutes", value: 1000 * 60 * 15 },
            { name: "30 minutes", value: 1000 * 60 * 30 },
            { name: "Disabled", value: 0 },
        ],
        autoRefreshInterval: defaultAutoRefreshInterval
    },
    getters: {
        autoRefreshOption(state) {
            return state.autoRefreshOptions.filter(o => +o.value === +state.autoRefreshInterval)[0];
        },
        autoRefreshOptions(state) {
            return state.autoRefreshOptions;
        },
        autoRefreshInterval(state) {
            return state.autoRefreshInterval;
        }
    },
    mutations: {
        SET_AUTO_REFRESH_INTERVAL(state, payload) {
            state.autoRefreshInterval = payload;
        }
    },
    actions: {
        getAutoRefreshInterval({ dispatch, getters }) {
            return localforage.getItem(autoRefreshIntervalKey)
                .then((value) => {
                    if (value == null) {
                        dispatch("setAutoRefreshInterval", defaultAutoRefreshInterval);
                        return defaultAutoRefreshInterval;
                    }
                    let option = getters.autoRefreshOptions.filter(o => +o.value === +value)[0];
                    if (option == null) {
                        dispatch("setAutoRefreshInterval", defaultAutoRefreshInterval);
                        return defaultAutoRefreshInterval;
                    }
                    dispatch("setAutoRefreshInterval", option.value);
                    return option.value;
                })
                .catch(err => console.error(err));
        },
        setAutoRefreshInterval({ commit }, payload) {
            commit("SET_AUTO_REFRESH_INTERVAL", payload);
            return localforage.setItem(autoRefreshIntervalKey, payload)
                .catch(err => console.error(err));
        }
    },
    modules: {
        sms
    }
};